
export default function HeroSection() {
  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://static.readdy.ai/image/2164e1b7672604a4b6f40cc0551a0838/90bd5e002d086e04e6364d602023e8ba.jpeg')`
      }}
    >
      <div className="container mx-auto px-4 text-center text-white">
        <div className="max-w-4xl mx-auto">
          <div className="flex items-center justify-center mb-6">
            <div className="text-6xl font-bold text-gray-300 mr-4">ZOLLER</div>
            <div className="w-16 h-16 bg-yellow-400 rounded-full flex items-center justify-center">
              <div className="w-8 h-8 border-4 border-gray-800 rounded-full"></div>
            </div>
          </div>
          
          <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
            自身の工場で見れるチャンス！
          </h1>
          
          <div className="text-2xl md:text-3xl font-semibold mb-8 text-yellow-400">
            smile on Tour
          </div>
          
          <p className="text-xl md:text-2xl mb-12 leading-relaxed">
            高精度・高機能ツールプリセッター「smile / pilot4.0」を<br />
            お客様の工場へお持ちし、実機デモンストレーションを実施
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="#demo" 
              className="bg-yellow-400 text-gray-900 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-yellow-300 transition-colors cursor-pointer whitespace-nowrap"
            >
              デモ申込はこちら
            </a>
            <a 
              href="#features" 
              className="border-2 border-white text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-white hover:text-gray-900 transition-colors cursor-pointer whitespace-nowrap"
            >
              製品特徴を見る
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
